var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcoDashboardNoData = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 56,
    height: 56.002,
    viewBox: "0 0 56 56.002",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Card_No_Data",
    "data-name": "Card_No Data",
    transform: "translate(-2026.683 -15549.145)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_40",
    "data-name": "Subtraction 40",
    d: "M-239.526,445.913c-.381,0-.783-.01-1.228-.031-.759-.03-1.528-.093-2.283-.188a27.8,27.8,0,0,1-5.947-1.422c-.8-.286-1.567-.6-2.287-.937A27.734,27.734,0,0,1-255,441.251a28.238,28.238,0,0,1-2.287-1.693,28.1,28.1,0,0,1-5.947-6.741,28.173,28.173,0,0,1-2.216-4.3,27.825,27.825,0,0,1-2.066-9.89l.471.306a4.522,4.522,0,0,0-.242,1.46,4.572,4.572,0,0,0,4.567,4.567,4.57,4.57,0,0,0,4.563-4.567,4.538,4.538,0,0,0-.734-2.479l10.208-11.058a4.527,4.527,0,0,0,2.17.547,4.538,4.538,0,0,0,3.852-2.125l7.8,2.534c-.007.1-.011.19-.011.291a4.569,4.569,0,0,0,4.567,4.562,4.567,4.567,0,0,0,4.563-4.562,4.612,4.612,0,0,0-.6-2.276l7.244-7.068a27.813,27.813,0,0,1,5.458,8.455,27.824,27.824,0,0,1,2.121,10.7,27.82,27.82,0,0,1-2.287,11.1,27.856,27.856,0,0,1-5.947,8.729,27.922,27.922,0,0,1-2.283,2.045,28.3,28.3,0,0,1-4.1,2.726c-.759.414-1.529.789-2.287,1.115a27.615,27.615,0,0,1-5.943,1.811c-.747.139-1.516.25-2.287.329a27.819,27.819,0,0,1-2.876.148Zm-26.286-28.884h0l-1.645-1.068c.013-.194.028-.376.042-.543.026-.294.056-.585.09-.887.063-.513.129-.957.2-1.358a28.011,28.011,0,0,1,9.45-16.584,27.888,27.888,0,0,1,8.311-4.9,27.888,27.888,0,0,1,9.838-1.778,27.9,27.9,0,0,1,9.625,1.7,27.827,27.827,0,0,1,8.177,4.692c.336.274.675.565,1,.867l-7.219,7.033a4.552,4.552,0,0,0-2.375-.665,4.548,4.548,0,0,0-3.855,2.121l-7.8-2.533c.007-.1.011-.193.011-.291a4.57,4.57,0,0,0-4.563-4.568,4.573,4.573,0,0,0-4.567,4.568,4.556,4.556,0,0,0,.733,2.479l-10.208,11.059a4.565,4.565,0,0,0-2.167-.548,4.579,4.579,0,0,0-3.092,1.2Z",
    transform: "translate(2294.203 15159.233)",
    fill: "rgba(159,168,191,0.08)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_66747",
    "data-name": "Path 66747",
    d: "M47.457,343.641v12.223a28.077,28.077,0,0,1-8.211-8.412v-3.811a1.677,1.677,0,0,1,1.677-1.676H45.78A1.677,1.677,0,0,1,47.457,343.641Zm0,0",
    transform: "translate(1991.608 15244.633)",
    fill: "rgba(124,141,168,0.2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_66748",
    "data-name": "Path 66748",
    d: "M177.715,246.684v27.422a27.8,27.8,0,0,1-8.21-1.607V246.684a1.676,1.676,0,0,1,1.676-1.677h4.857a1.676,1.676,0,0,1,1.676,1.677Zm0,0",
    transform: "translate(1875.617 15331.013)",
    fill: "rgba(124,141,168,0.2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_66749",
    "data-name": "Path 66749",
    d: "M311.334,290.1v19.321a27.668,27.668,0,0,1-8.209,2.919V290.1a1.677,1.677,0,0,1,1.677-1.677h4.856a1.677,1.677,0,0,1,1.677,1.677Zm0,0",
    transform: "translate(1756.618 15292.336)",
    fill: "rgba(124,141,168,0.2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_66750",
    "data-name": "Path 66750",
    d: "M443.268,158.156a1.676,1.676,0,0,1,1.677,1.676v9a27.838,27.838,0,0,1-8.211,19.778V159.832a1.677,1.677,0,0,1,1.677-1.676Zm0,0",
    transform: "translate(1637.628 15408.39)",
    fill: "rgba(124,141,168,0.2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Group_46535",
    "data-name": "Group 46535",
    d: "M-263.607,421.281a4.055,4.055,0,0,1,.217-1.316l-4.032-2.613q.1-1.131.291-2.24l4.855,3.147a4.1,4.1,0,0,1,2.785-1.084,4.12,4.12,0,0,1,1.957.493l9.2-9.944a4.077,4.077,0,0,1-.661-2.235,4.105,4.105,0,0,1,4.111-4.1h.006a4.105,4.105,0,0,1,4.111,4.1,2.57,2.57,0,0,1-.009.264l7.03,2.278a4.113,4.113,0,0,1,3.478-1.908,4.108,4.108,0,0,1,2.143.6l8.9-8.659a4.075,4.075,0,0,1-.548-2.046,4.115,4.115,0,0,1,4.117-4.107,4.113,4.113,0,0,1,4.117,4.107,4.105,4.105,0,0,1-4.111,4.1h-.006a4.113,4.113,0,0,1-2.144-.6l-8.9,8.661a4.071,4.071,0,0,1,.547,2.048,4.113,4.113,0,0,1-4.111,4.106,4.113,4.113,0,0,1-4.117-4.106,2.558,2.558,0,0,1,.009-.264l-7.03-2.276a4.113,4.113,0,0,1-3.474,1.906,4.119,4.119,0,0,1-1.956-.491l-9.2,9.946a4.077,4.077,0,0,1,.661,2.23,4.114,4.114,0,0,1-4.117,4.106,4.113,4.113,0,0,1-4.119-4.1Z",
    transform: "translate(2294.105 15159.233)",
    fill: "rgba(124,141,168,0.4)"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcoDashboardNoData);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ico_dashboard_no_data.fe17c3b9e3d2546e7871cbe68bdb61b9.svg";